import { useRef, useEffect, FC } from 'react';

function preventDefaults(event: any) {
  event.preventDefault();
  event.stopPropagation();
}

type Props = {
  onDrop: Function,
  onLeave?: Function,
  onEnter?: Function
}

enum Events {
  DRAGENTER = 'dragenter',
  DRAGOVER = 'dragover',
  DRAGLEAVE = 'dragleave',
  DROP = 'drop',
}

export const DropZone: FC<Props> = ({ onDrop, onLeave, onEnter, children }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      const node = ref.current;

      [Events.DRAGENTER, Events.DRAGOVER, Events.DRAGLEAVE, Events.DROP].forEach(eventName => {
        node.addEventListener(eventName, preventDefaults, false);
      });

      [Events.DRAGENTER, Events.DRAGOVER].forEach(eventName => {
        if (onEnter) {
          node.addEventListener(eventName, onEnter, false);
        }
      });

      [Events.DRAGLEAVE, Events.DROP].forEach(eventName => {
        if (onLeave) {
          node.addEventListener(eventName, onLeave, false);
        }
      });

      const handleDrop = (event: any) => {
        onDrop(event.dataTransfer.files);
      }

      node.addEventListener(Events.DROP, handleDrop, false)

      return () => {
        [Events.DRAGENTER, Events.DRAGOVER, Events.DRAGLEAVE, Events.DROP].forEach(eventName => {
          node.removeEventListener(eventName, preventDefaults, false);
        });

        [Events.DRAGENTER, Events.DRAGOVER].forEach(eventName => {
          if (onEnter) {
            node.removeEventListener(eventName, onEnter, false);
          }
        });

        [Events.DRAGLEAVE, Events.DROP].forEach(eventName => {
          if (onLeave) {
            node.removeEventListener(eventName, onLeave, false);
          }
        });

        node.removeEventListener(Events.DROP, handleDrop, false);
      };
    }
  }, [onDrop, onEnter, onLeave]);

  return (
    <div ref={ref}>
      {children}
    </div>
  );
}